import Splide from '@splidejs/splide';

const EL = '.js-history'
const ACTIVE_CLASS = 'is-active'
const ELS = document.querySelectorAll(EL);

ELS.forEach((EL) => {
  new Splide( EL, {
    arrows: true,
    pagination: false,
    fixedWidth: '516px',
    height: '594px',
    drag: 'free',
    breakpoints: {
      768: {
        fixedWidth: '100%',
        drag: true,
        height: '100%'
      },
      1024: {
        fixedWidth: '400px',
      }
    }
  } ).mount();
});
